module.exports = __webpack_public_path__ + "static/media/export.13adf7bd.svg";